import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { RegionService } from '../shared/region.service';
import { DataTableColumn } from '../../shared/data-table/data-table.component';
import { SortDirection } from '../../shared/sort-direction';
import { RegionSearchCriteria } from '../shared/region-search-criteria.model';
import { NavigationService } from '../../shared/services/navigation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { Languages } from '../../core/languages';

@Component({
  selector: 'app-region-list',
  templateUrl: './region-list.component.html',
  styleUrls: ['./region-list.component.scss']
})
export class RegionListComponent implements OnInit {

  noResult: boolean = undefined;
  readonly Languages = Languages;

  filters: RegionSearchCriteria = {};

  @ViewChild('nameColumn', { static: true })
  nameColumn: TemplateRef<any>;

  @ViewChild('languageColumn', { static: true })
  languageColumn: TemplateRef<any>;

  @ViewChild('timezoneColumn', { static: true })
  timezoneColumn: TemplateRef<any>;

  @ViewChild('tmsSynchronizationColumn', { static: true })
  tmsSynchronizationColumn: TemplateRef<any>;

  @ViewChild('countriesColumn', { static: true })
  countriesColumn: TemplateRef<any>;

  columns: DataTableColumn[] = [];
  sortColumn: DataTableColumn;
  SortDirection = SortDirection;

  loadPage = (page: number, pageSize: number, sortColumn: DataTableColumn, direction: SortDirection) =>
    this.regionService.search(page - 1, pageSize, sortColumn.name, direction, this.filters).pipe(
      tap(result => this.noResult = !result.count)
    );

  constructor(
    private regionService: RegionService,
    private navigation: NavigationService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
  }

  ngOnInit() {
    const nameColumn = {
      name: 'name',
      displayed: true,
      translationKey: 'regions.list.table.name',
      template: this.nameColumn,
      sortable: true
    };

    this.columns = [
      nameColumn,
      {
        name: 'language',
        displayed: true,
        translationKey: 'regions.list.table.language',
        template: this.languageColumn,
        sortable: false
      },
      {
        name: 'timezone',
        displayed: true,
        translationKey: 'regions.list.table.timezone',
        template: this.timezoneColumn,
        sortable: false
      },
      {
        name: 'tmsSynchronization',
        displayed: true,
        translationKey: 'regions.list.table.tmsSynchronization',
        template: this.tmsSynchronizationColumn,
        sortable: false
      },
      {
        name: 'countries',
        displayed: true,
        translationKey: 'regions.list.table.countries',
        template: this.countriesColumn,
        sortable: false
      }
    ];

    this.sortColumn = nameColumn;
    this.route.queryParams.subscribe(params => {
      this.filters.name = params.name;
      this.filters.country = params.country;
    });
  }

  goToCreateRegion() {
    this.navigation.regions()
      .create()
      .go();
  }

  goToEditRegion(regionId: string) {
    this.navigation.regions()
      .edit(regionId)
      .go();
  }

  pageLoaded() {
    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: this.filters
      }
    );
  }

  formatTmsSyncTimeslot(tmsSyncTimeSlot: string): string {
    return tmsSyncTimeSlot ? tmsSyncTimeSlot.toLowerCase().replace('_', '') : '';
  }
}
